import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const RangeDatePickerWrapper = styled.div`
  position: relative;
`;

export const RangeDatePickerSelectorWrapper = styled.div`
  position: absolute;

  & .rdrCalendarWrapper {
    background-color: ${({ theme }) => theme.colors.grey100};
    border: 1px solid ${({ theme }) => theme.colors.grey002};
  }
`;

export const RangeDatePickerLabel = styled(typography.BodyTextOneRegularTypography)`
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0;
  padding: 0 12px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid #d7dce3;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
`;
